import * as yup from 'yup';
import { Fields } from '~/features/checkout/models/fields';
import { useTranslation } from '~/shared/utils/translation';
import { isAddress1, isPhone, isZipCode, isName } from '~/utils/form-validators';

/**
 * Yup documentaion https://github.com/jquense/yup
 * @returns validation schema
 */

export const useValidationSchema = () => {
    const { translate } = useTranslation();

    return yup.object().shape({
        [Fields.FirstName]: yup.string().when(Fields.SameDeliveryAddress, {
            is: false,
            then: yup
                .string()
                .required('')
                .trim()
                .matches(
                    isName,
                    translate('message.firstnameValidationError') ||
                        'Fornavn må kun indeholde bogstaver, mellemrum, komma, punktum og bindestreg'
                ),
        }),
        [Fields.LastName]: yup.string().when(Fields.SameDeliveryAddress, {
            is: false,
            then: yup
                .string()
                .required('')
                .trim()
                .matches(
                    isName,
                    translate('message.lastnameValidationError') ||
                        'Efternavn må kun indeholde bogstaver, mellemrum, komma, punktum og bindestreg'
                ),
        }),

        [Fields.Address1]: yup.string().when(Fields.SameDeliveryAddress, {
            is: false,
            then: yup
                .string()
                .required('')
                .matches(isAddress1, translate('message.addressMissingHouseNumber'))
                .max(35, translate('message.addressLengthValidationError')),
        }),

        [Fields.Address2]: yup.string().when(Fields.SameDeliveryAddress, {
            is: false,
            then: yup.string().max(35, translate('message.addressLengthValidationError')),
        }),

        [Fields.PostalCode]: yup.string().when(Fields.SameDeliveryAddress, {
            is: false,
            then: yup.string().required('').matches(isZipCode),
        }),

        [Fields.City]: yup.string().when(Fields.SameDeliveryAddress, {
            is: false,
            then: yup.string().required(''),
        }),

        [Fields.Phone]: yup.string().when(Fields.SameDeliveryAddress, {
            is: false,
            then: yup
                .string()
                .required('')
                .matches(isPhone, translate('message.phoneValidationError')),
        }),
    });
};
